import { render, staticRenderFns } from "./BrandingView.vue?vue&type=template&id=3dd7925e&scoped=true"
import script from "./BrandingView.vue?vue&type=script&lang=js"
export * from "./BrandingView.vue?vue&type=script&lang=js"
import style0 from "./BrandingView.vue?vue&type=style&index=0&id=3dd7925e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd7925e",
  null
  
)

export default component.exports